import { useEffect, useState } from 'react';
import { getMegamenuNavItems } from '@yme/api';
import { PAGE_TYPE, PLP_TYPE } from '@yme/common//constants';
import { EXTRA_MENU_TYPE } from '@yme/components/Header/constants';
/*
  We need it to stop menu blinking when user navigates from one page to another
  Since useMenuContext used only once and only for purpose of menu loading and updating,
  we could keep previous data until new data is loaded and then update it.

  It's safe from content point of view, because navigation is not expanded after page transition, and updated menu appear in 1-2 seconds.
*/
let prevData = [];
export const useMenuContext = (megamenuURL) => {
    const [initialChildren, setInitialChildren] = useState({
        title: '',
        pageType: '',
        items: prevData,
    });
    const [children, setChildren] = useState({
        title: '',
        pageType: '',
        items: prevData,
    });
    const [prevs, setPrevs] = useState([]);
    const [parentType, setParentType] = useState('');
    const [navButtonsContent, setNavButtonsContent] = useState({
        [PLP_TYPE]: {
            title: '',
            link: '',
        },
        [EXTRA_MENU_TYPE]: {
            title: '',
            link: '',
        },
        [PAGE_TYPE]: {
            title: '',
            link: '',
        },
    });
    const setMenuChildren = (child) => {
        setChildren(child);
    };
    useEffect(() => {
        (async () => {
            try {
                const result = await getMegamenuNavItems(megamenuURL);
                prevData = result?.navItems.childPages ?? [];
                setChildren({
                    title: '',
                    items: result?.navItems.childPages,
                    pageType: '',
                });
                setInitialChildren({
                    title: '',
                    items: result?.navItems.childPages,
                    pageType: '',
                });
            }
            catch (err) {
                setChildren({
                    title: '',
                    pageType: '',
                });
            }
        })();
    }, [megamenuURL]);
    const setPrevPages = (prevPages) => {
        setPrevs((prevState) => prevState.concat(prevPages));
    };
    const returnToPrev = () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setChildren(prevs?.slice()?.pop());
        setPrevs((prevValue) => prevValue.slice(0, -1));
    };
    const setParentPageType = (type) => {
        setParentType(type);
    };
    const setButtonsContent = (key, value) => {
        setNavButtonsContent((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };
    return {
        prevs,
        initialChildren,
        children,
        parentType,
        setPrevs,
        setPrevPages,
        returnToPrev,
        setMenuChildren,
        setParentPageType,
        setNavButtonsContent: setButtonsContent,
        navButtonsContent,
    };
};
